import React, { useRef, useEffect, useState } from "react";
import styles from './Loading.module.less';
export function AutoLoading(_a) {
    var loading = _a.loading, children = _a.children;
    var ref = useRef(null);
    var _b = useState({
        width: 0,
        height: 0,
        fontSize: 12
    }), state = _b[0], setState = _b[1];
    useEffect(function () {
        if (loading) {
            var node = ref.current;
            var parentNode = node && node.parentNode;
            if (node && parentNode) {
                var _a = parentNode.getBoundingClientRect(), width = _a.width, height = _a.height;
                setState({
                    height: height,
                    width: width,
                    fontSize: Math.min(64, width * 0.15)
                });
            }
        }
    }, [loading]);
    return (React.createElement(React.Fragment, null, loading
        ? (React.createElement("div", { className: styles.WKloadMoreWrap },
            React.createElement("i", { className: styles.WKloadMore })))
        : children));
}



//////////////////
// WEBPACK FOOTER
// ./src/components/auto-loading/index.tsx
// module id = 199
// module chunks = 41